/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSecteurGridDto } from './FcbSecteurGridDto';
import {
    FcbSecteurGridDtoFromJSON,
    FcbSecteurGridDtoFromJSONTyped,
    FcbSecteurGridDtoToJSON,
} from './FcbSecteurGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSecteurGridDtoPaginatedResults
 */
export interface FcbSecteurGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSecteurGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSecteurGridDto>}
     * @memberof FcbSecteurGridDtoPaginatedResults
     */
    results?: Array<FcbSecteurGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSecteurGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSecteurGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSecteurGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSecteurGridDtoPaginatedResultsFromJSON(json: any): FcbSecteurGridDtoPaginatedResults {
    return FcbSecteurGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSecteurGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSecteurGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSecteurGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSecteurGridDtoPaginatedResultsToJSON(value?: FcbSecteurGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSecteurGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

